import React from "react";
import logo from "../../logo.png"; // use your logo path
import "./loader.css"; // create this CSS file for styling the loader

function Loader() {
  return (
    <div className="loader-container">
      <img src={logo} alt="Logo" className="loader-logo" />
    </div>
  );
}

export default Loader;